import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./CustomTooltip.scss";
import { useEffect, useState } from "react";

const CustomTooltip = ({
  text,
  children,
  classString,
  placement,
  disabled = 0,
  tooltipClassName = "",
  hideOnScroll = false,
}) => {
  const [isScrolling, setIsScrolling] = useState(false);

  let tooltipContainer = null;

  if (classString) {
    tooltipContainer =
      typeof classString === "string"
        ? document.querySelector(classString)
        : classString;
  }

  useEffect(() => {
    if (!hideOnScroll) {
      return undefined;
    }

    let timeout;

    const handleScroll = () => {
      setIsScrolling(true);

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        setIsScrolling(false);
      }, 150);
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [hideOnScroll]);

  const renderTooltip = () => (
    <Tooltip
      id="tooltip"
      className={`custom-tooltip-black ${tooltipClassName}`}
      style={{
        display: disabled || isScrolling ? "none" : "block",
      }}
    >
      {text}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      trigger={["hover"]}
      placement={placement ?? "top"}
      overlay={renderTooltip()}
      container={tooltipContainer}
      show={isScrolling ? false : undefined}
    >
      {children}
    </OverlayTrigger>
  );
};

CustomTooltip.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  classString: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  placement: PropTypes.string,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  tooltipClassName: PropTypes.string,
  hideOnScroll: PropTypes.bool,
};

export default CustomTooltip;
